import * as $ from 'jquery';
import moment from 'moment';
import { pageLang } from '../../services/app-storage';
import { addDatePicker, addDateTimePicker } from '../../services/datepicker';
import { getWidgetForm } from './models/form';

export default function loadDatePickers(): void {
    addDatePicker($('.datepicker'), { minimum: moment().startOf('day') });
    addDateTimePicker($('.datetimepicker'), { minimum: moment() });

    setDefaultValues();
}

function setDefaultValues(): void {
    const defaultDate = moment().startOf('day')
        .add({ days: 2, hours: 13 })
        .locale(pageLang);

    const form = getWidgetForm();
    form.row1.noflight.datetime.val(defaultDate.format());
    form.row1.noflight.datetime.val(defaultDate.format());

    defaultDate.add({ days: 1 });
    form.row2.noflight.datetime.val(defaultDate.format());
    form.row2.noflight.datetime.val(defaultDate.format());
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/datepicker.ts